<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas3bg.svg" />
    <p id="text01" class="textBase pageElement">
      Había una vez, en un reino muy lejano, un rey que tenía 3 hijos. Los dos
      mayores habían salido de viaje, a recorrer el mundo. Pasaban los meses y
      no volvían a su casa. Como su padre los extrañaba mucho, el hermano menor
      salió a buscarlos. Anduvo muchos días y muchas noches hasta que,
      finalmente, los encontró.<br /><br />
      El hermano menor, que se llamaba Serafín, les pidió a sus hermanos que
      volvieran a casa. Pero ellos le dijeron que no ¿Dónde se ha visto que los
      hermanos mayores le hagan caso al hermano menor?
    </p>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 13px;
  top: 42px;
}
#text01 {
  position: absolute;
  width: 567px;
  height: 423px;
  left: 41px;
  top: 175px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 2b.mp4", "cas/Video 3.mp4",],
    }
  }
}
</script>